var _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntrance6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.53,
    height: 34.96,
    viewBox: "0 0 33.53 34.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 11.56 3.25 29.04 20.02 34.96 19.07 15.05 0 11.56",
    fill: "#c5dedd"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "30.28 5.92 33.53 23.4 20.02 34.96 16.77 17.48 18.82 9.36 30.28 5.92",
    fill: "#d6e8e7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "16.77 17.48 30.28 5.92 13.51 0 0 11.56 16.77 17.48",
    fill: "#e8f2f1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrance6);
export default __webpack_public_path__ + "static/media/entrance_6.3609097afd560f500321dea6aeb8fd51.svg";
export { ForwardRef as ReactComponent };